import { useEffect, useState } from 'react';
import InputField from '../../components/input';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoginCredentials, loginUser, logout } from '../../auth/userSlice';
import './index.css'
import { useAddDispatch } from '../../store';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { UserTypePartner, UserTypePermanent } from '../../constants/constant';


function Login(props: any) {
    const domain = window.location.hostname;
    const navigate = useNavigate();
    const dispatch = useAddDispatch();
    const initialValues: LoginCredentials = {
        emailOrMobileNo: '',
        password: '',
        companyCode: domain.includes("tctdmc.com") ? "TCT" : "GW",
        userType: domain.includes("partner") ? UserTypePartner : UserTypePermanent
    };
    const [errormsg, setErrormsg] = useState("");

    const signinSchema = Yup.object().shape({
        emailOrMobileNo: Yup.string()
            .required('Email or Mobile No is required'),
        password: Yup.string()
            .required('Password is required')
    });

    const handleSubmit = async (values: any) => {
        setErrormsg("");
        const response = await dispatch(loginUser(values));

        if (response?.payload?.isSuccess) {
            sessionStorage.setItem("user", JSON.stringify(response?.payload?.result));
            //let access_token = response?.payload?.result?.token;
            navigate('/dashboard');
        } else {
            setErrormsg("Email or Mobile No or password is incorrect");
            console.log(response?.payload);
            return false;
        }
    }
    useEffect(() => {
        dispatch(logout())
        sessionStorage.removeItem("user");

    }, [dispatch]);

    return (
        <>
            <div className="container-fluid page-body-wrapper full-page-wrapper transparent-bg">
                <div className="login-content-wrapper content-wrapper d-flex align-items-center auth px-0">
                    <div className="row w-100 mx-0">
                        <div className="col-lg-4 mx-auto">
                            <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                                {/* <div className="brand-logo">
                                    <img src="assets/images/logo.png" alt="logo"></img>
                                </div> */}
                                <h6 className="font-weight-light">Sign in to continue.</h6>
                                <Formik
                                    initialValues={initialValues}
                                    validationSchema={signinSchema}
                                    onSubmit={(values, actions) => {
                                        //console.log({ values, actions });
                                        //alert(JSON.stringify(values, null, 2));
                                        handleSubmit(values);
                                        actions.setSubmitting(false);
                                    }}
                                >
                                    {({ values, errors, touched, isSubmitting, handleChange, handleSubmit }) => (
                                        <form className="pt-3">
                                            <div className="form-group">
                                                <InputField
                                                    selectedValue={values.emailOrMobileNo} onChange={handleChange}
                                                    className={`form-control form-control-lg bg-white ${errors.emailOrMobileNo && touched.emailOrMobileNo ? "is-invalid" : ""}`}
                                                    name="emailOrMobileNo"
                                                    placeholder="Email or Mobile No" />
                                                {errors.emailOrMobileNo && touched.emailOrMobileNo ? (<p style={{ color: 'red' }}>{errors.emailOrMobileNo}</p>) : null}
                                            </div>
                                            <div className="form-group">
                                                <InputField selectedValue={values.password} onChange={handleChange}
                                                    type="password" className={`form-control form-control-lg bg-white ${errors.password && touched.password ? "is-invalid" : ""}`}
                                                    name="password"
                                                    placeholder="Password" />
                                                {errors.password && touched.password ? (<p style={{ color: 'red' }}>{errors.password}</p>) : null}
                                            </div>
                                            <div className="mt-3 d-grid gap-2">
                                                <button type="submit" disabled={isSubmitting} onClick={(e: any) => { handleSubmit(e) }}
                                                    className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">
                                                    {isSubmitting ? 'SIGN IN...' : 'SIGN IN'}</button>
                                                {errormsg && <p style={{ color: 'red' }}>{errormsg}</p>}
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
                {/* content-wrapper ends */}
            </div>
            {/* page-body-wrapper ends  */}
        </>
    )
}
export default Login;
